import { ITheme, IStyle, mergeStyleSets, getTheme } from '@fluentui/react';
import React, { useMemo } from 'react';

interface ILightProductTexture {
  id: string;
  name: string;
  swatchUrl: string;
}
export interface IProductVariantLabelProps {
  texture: ILightProductTexture;
  size: number;
}

const getStyleClasses = (theme: ITheme) => {
  const root: IStyle = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '0.3em',
  };
  
  const swatchBorder: IStyle = {
    boxSizing: 'border-box',
    width: '1em',
    height: '1em',
    borderRadius: '0.5em',
    border: `0.06em solid ${theme.palette.neutralSecondary}`,
    backgroundColor: theme.palette.white,
    position: 'relative',
  };

  const swatch: IStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '0.8em',
    height: '0.8em',
    borderRadius: '0.396em',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    position: 'absolute',
    left: '0.04em',
    top: '0.04em',
  };
  
  const label: IStyle = {
    display: 'block',
    fontSize: '0.65em',
    fontWeight: 500,
    lineHeight: '0.85em',
    margin: 0,
    padding: 0,
  };

  return mergeStyleSets({
    root,
    swatchBorder,
    swatch,
    label,
  });
}

export const ProductVariantLabel: React.FunctionComponent<IProductVariantLabelProps> = (props) => {
  const theme = getTheme();
  const cs = getStyleClasses(theme);
  const { texture } = props;
  const swatchStyle = useMemo<React.CSSProperties>(() => {
    const media = texture.swatchUrl;
    if(media[0] === '#') {
      return { backgroundColor: media };
    }
    return { backgroundImage: `url("${media}")` };
  }, [texture]);

  return (
    <div
    id={`var-label-${texture.id}`}
    className={cs.root}
    style={{ fontSize: `${props.size}rem`}}>
      <div className={cs.swatchBorder} >
        <div
          className={cs.swatch}
          style={swatchStyle}
          aria-label={`Selected color / finish: ${texture.name}`}
        />
      </div>
      <label
        htmlFor={`var-label-${texture.id}`}
        className={cs.label}
      >
        {texture.name}
      </label>
    </div>
  );
};
